function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.60938 11.8594C3.30469 12.1406 2.83594 12.1406 2.53125 11.8594L0.28125 9.60938C0 9.30469 0 8.83594 0.28125 8.53125C0.585938 8.25 1.05469 8.25 1.35938 8.53125L2.32031 9.51562V0.820312C2.32031 0.398438 2.64844 0.0703125 3.07031 0.0703125C3.49219 0.0703125 3.82031 0.398438 3.82031 0.820312V9.51562L4.78125 8.53125C5.08594 8.25 5.55469 8.25 5.85938 8.53125C6.14062 8.83594 6.14062 9.30469 5.85938 9.60938L3.60938 11.8594ZM9.60938 0.28125L11.8594 2.53125C12.1406 2.83594 12.1406 3.30469 11.8594 3.60938C11.5547 3.89062 11.0859 3.89062 10.7812 3.60938L9.82031 2.625V11.3203C9.82031 11.7422 9.49219 12.0703 9.07031 12.0703C8.64844 12.0703 8.32031 11.7422 8.32031 11.3203V2.625L7.35938 3.60938C7.05469 3.89062 6.58594 3.89062 6.28125 3.60938C6 3.30469 6 2.83594 6.28125 2.53125L8.53125 0.28125C8.83594 0 9.30469 0 9.60938 0.28125Z",
  fill: "#000000"
});

function SvgArrowDownArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownArrowUp);
export default __webpack_public_path__ + "static/media/arrow-down-arrow-up.10e8e0e0.svg";
export { ForwardRef as ReactComponent };